import type { LicenseResponseBody } from '@/features/Licenses/api/licenseHooks'

export const hasStripeBilling = (license: LicenseResponseBody): boolean =>
  !!license.subscriptionId

export const isSelfServiceLicense = (license: LicenseResponseBody): boolean =>
  !license.origin || license.origin === 'self-service'

/**
 * Whether `reference` may be cleared on this license.
 *
 * The license-service enforces `reference is required when origin is not
 * self-service` and rejects a clearing update with 422
 * (`code: REFERENCE_REQUIRED_FOR_ORIGIN`). A missing origin counts as
 * self-service — that is the upstream's own rule, not a frontend guess, and it
 * matters because `origin` is absent on licenses created before the field
 * existed.
 */
export const canClearLicenseReference = (
  license: LicenseResponseBody,
): boolean => isSelfServiceLicense(license)
